import { useEffect, useMemo, useRef, useState } from 'react';

const useFaqItem = (answer) => {
  const answerRef = useRef();
  const [windowWidth, setWindowWidth] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) {
      const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth);
      };
      updateWindowWidth();
      window.addEventListener('resize', updateWindowWidth);
      return () => {
        window.removeEventListener('resize', updateWindowWidth);
      };
    }
    return () => {};
  }, [show]);

  const answerHeight = useMemo(() => {
    if (answerRef.current) {
      return answerRef.current.clientHeight;
    }
    return 0;
  }, [show, windowWidth, answer]); // eslint-disable-line

  return [answerRef, show, setShow, answerHeight];
};

export default useFaqItem;
